<template>
  <el-dialog
    :title="'修改商户信息 - ' + editStoreAttr.name"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form :model="editStoreAttr" label-width="120px">
      <el-form-item :label="editStoreAttr.name">
        <el-input 
          v-model="editStoreAttr.value" 
          placeholder="商户属性必填"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="submitEditStoreAttr">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateStoreAttr } from '@/api/common/storeInfoManage/storeInfoManageApi'

export default {
  name: 'EditStoreAttr',
  data() {
    return {
      dialogVisible: false,
      editStoreAttr: {
        attrId: '',
        value: '',
        name: ''
      }
    }
  },
  methods: {
    open(storeAttr) {
      this.refreshEditStoreAttr(storeAttr)
      this.dialogVisible = true
    },
    refreshEditStoreAttr(storeAttr) {
      this.editStoreAttr = {
        attrId: storeAttr.attrId,
        value: storeAttr.value,
        name: storeAttr.name
      }
    },
    handleClose() {
      this.clearEditStoreAttr()
    },
    clearEditStoreAttr() {
      this.editStoreAttr = {
        attrId: '',
        value: '',
        name: ''
      }
    },
    editStoreAttrValidate() {
      if (!this.editStoreAttr.value) {
        this.$message.error('属性值必填')
        return false
      }
      return true
    },
    submitEditStoreAttr() {
      if (!this.editStoreAttrValidate()) return
      
      updateStoreAttr(this.editStoreAttr)
        .then(() => {
          this.$message.success('修改成功')
          this.dialogVisible = false
          this.$emit('refresh')
        })
        .catch(error => {
          console.error('修改失败', error)
        })
    }
  }
}
</script>